/* oxlint-disable */
'use client';
import Image from 'next/image';

import bitcoin from '@/public/img/footer/bitcoin.webp';
import visa from '@/public/img/footer/visaM.png';
import pybam from '@/public/img/v2/deposit/icons/pybam.svg';
import ikisi from '@/public/img/v2/deposit/icons/pyikisi.png';
import pybi from '@/public/img/v2/deposit/icons/pybi.png';
import super24 from '@/public/img/v2/deposit/icons/pysuper24.png';
import midas from '@/public/img/v2/deposit/icons/midasRd.png';
import popular from '@/public/img/v2/deposit/icons/popularRd.png';

import paymentMethodsSection from './localization/core';
import { useEffect, useState } from 'react';
import { useAuth } from '@/core/auth/client/AuthProvider';

const paymentMethods = [
  {
    id: 2,
    name: paymentMethodsSection.paymentMethodsSection.bitcoin,
    image: bitcoin.src,
    country: 'GLOBAL',
  },
  {
    id: 3,
    name: paymentMethodsSection.paymentMethodsSection.ikisi,
    image: ikisi.src,
    country: 'GT',
  },
  {
    id: 4,
    name: paymentMethodsSection.paymentMethodsSection.pybam,
    image: pybam.src,
    country: 'GT',
  },
  {
    id: 5,
    name: paymentMethodsSection.paymentMethodsSection.pybi,
    image: pybi.src,
    country: 'GT',
  },
  {
    id: 6,
    name: paymentMethodsSection.paymentMethodsSection.super24,
    image: super24.src,
    country: 'GT',
  },
  {
    id: 7,
    name: paymentMethodsSection.paymentMethodsSection.visa,
    image: visa.src,
    country: 'GLOBAL',
  },
  {
    id: 8,
    name: paymentMethodsSection.paymentMethodsSection.midas,
    image: midas.src,
    country: 'RD',
  },
  {
    id: 9,
    name: paymentMethodsSection.paymentMethodsSection.popular,
    image: popular.src,
    country: 'RD',
  },
];

const PaymentMethods = () => {
  const [country, setCountry] = useState('GLOBAL');
  const { session } = useAuth();
  useEffect(() => {
    setCountry((session as any)?.session?.country || 'GLOBAL');
  }, [session]);
  return (
    <div>
      <h4 className="mx-0 text-center font-bold text-lg">{paymentMethodsSection.paymentMethodsSection.title}</h4>
      <div className="flex flex-row gap-2 justify-center items-center z-50">
        {paymentMethods.map((method) => {
          if (method.country !== country && method.country !== 'GLOBAL') return null;
          return (
            <Image key={method.id} src={method.image} alt={method.name} width={80} height={36} className="object-contain h-9 w-20" />
          );
        })}
      </div>
    </div>
  );
};

export default PaymentMethods;
